<template>
  <div>
    <a-row id="login" type="flex" justify="center" align="middle">
      <a-col :span="17" class="bg-pannel">
        <img
          style="max-height: calc(100vh - 64px)"
          src="./loginbg.jpg"
          alt=""
        />
      </a-col>
      <a-col flex="400px" class="login-pannel">
        <a-card
          style="
            border-radius: 20px;
            box-shadow: rgb(179, 179, 179) 0px 0px 5px;
          "
        >
          <h1 style="text-align: center">查询入口</h1>
          <a-form
            :form="form"
            class="user-layout-login"
            ref="formLogin"
            id="formLogin"
            layout="horizontal"
          >
            <a-form-item
              label="档 案 号"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                size="large"
                v-decorator="[
                  'username',
                  { initialValue: '', rules: validatorRules.username.rules },
                ]"
                type="text"
                placeholder="请输入身份证号/手机号"
              >
                <a-icon
                  slot="prefix"
                  type="user"
                  :style="{ color: 'rgba(0,0,0,.25)' }"
                />
              </a-input>
            </a-form-item>

            <a-form-item
              label="查询密码"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                v-decorator="[
                  'password',
                  {
                    initialValue: '',
                    rules: validatorRules.password.rules,
                  },
                ]"
                size="large"
                type="password"
                autocomplete="false"
                placeholder="密码"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  :style="{ color: 'rgba(0,0,0,.25)' }"
                />
              </a-input>
            </a-form-item>
            <a-form-item style="margin-top: 24px">
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-button
                    type="primary"
                    htmlType="submit"
                    class="login-button"
                    :loading="loginBtn"
                    @click.stop.prevent="handleSubmit"
                    :readOnly="loginBtn"
                    >查询
                  </a-button>
                </a-col>
                <a-col :span="12">
                  <a-button
                    type="primary"
                    class="login-button"
                    @click="handleClickForgetPwd"
                    >重置密码
                  </a-button>
                </a-col>
              </a-row>
            </a-form-item>
          </a-form>
          <div>
            <p>1、本人凭身份证号码+密码查询</p>
            <p>
              2、非本人的查询，仅限相关教育主管部门、科技人才选拔认证、高校招生办等单位进行申请查询权限后查询
            </p>
          </div>
        </a-card>
      </a-col>
    </a-row>
    <div class="footer">
      <h2>Copyright 2023 中国自动化学会智慧教育专业委员会 普及工作委员会</h2>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Vue from 'vue'
import { TENANT_CONFIG, ACCESS_TOKEN } from "@/store/mutation-types";
import { putAction, postAction, getAction } from "@/api/manage";

export default {
  name: "AidocLogin",
  data() {
    return {
      loginBtn: false,
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      validatorRules: {
        username: {
          rules: [
            { required: true, message: "请输入身份证号/手机号!" },
            { validator: this.handleUsernameOrEmail },
          ],
        },
        password: {
          rules: [
            { required: true, message: "请输入密码!", validator: "click" },
          ],
        },
      },
      currdatetime: "",
    };
  },
  created() {
    this.currdatetime = new Date().getTime();
    let token = Vue.ls.get(ACCESS_TOKEN)
    if(token){
      this.$router.push("/cert/aidocList");
    }
  },
  mounted() {
    let that = this;
    setInterval(function () {
      that.hide53kf();
    }, 500);
  },
  methods: {
    ...mapActions(["Login"]),
    toLogin() {
      this.$el
        .querySelector("#login")
        .scrollIntoView({ block: "start", behavior: "smooth" });
    },
    handleUsernameOrEmail(rule, value, callback) {
      const regex =
        /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
      if (regex.test(value)) {
        this.loginType = 0;
      } else {
        this.loginType = 1;
      }
      callback();
    },
    handleSubmit() {
      let that = this;
      let loginParams = {};
      that.loginBtn = true;
      // 使用账户密码登录
      that.form.validateFields(
        ["username", "password"],
        { force: true },
        (err, values) => {
          if (!err) {
            loginParams.username = values.username;
            loginParams.password = values.password;
            loginParams.checkKey = that.currdatetime;
            loginParams.captcha = "1817"
            console.log("登录参数", loginParams);
            that
              .Login(loginParams)
              .then((res) => {
                that.loginBtn = false;
                this.$router.push("/cert/aidocList");
              })
              .catch((err) => {
                this.$notification["error"]({
                  message: "登录失败",
                  description:
                    ((err.response || {}).data || {}).message ||
                    err.message ||
                    "请求出现错误，请稍后再试",
                  duration: 4,
                });
                that.loginBtn = false;
              });
          } else {
            that.loginBtn = false;
          }
        }
      );
    },
    handleClickForgetPwd() {
      this.$router.push({ name: "find" });
    },
    hide53kf() {
      let kfdom = document.getElementById("icon_module");
      if (kfdom) {
        kfdom.style.display = "none";
      }
    },
  },
};
</script>

<style lang="less" scoped>

#login{
  min-height: 100vh;
  max-width: 1400px;
  margin: auto;
}
.bg-pannel {
  img {
    max-width: 100%;
  }
}
.login-pannel {
  padding: 16px;
}
.user-layout-login {
  label {
    font-size: 14px;
  }
  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    width: 100px;
    display: block;
    margin: auto;
  }
}
.footer {
  text-align: center;
  bottom: 0;
  position: absolute;
  margin-top: 32px;
  width: 100%;
  height: 32px;
}
</style>